var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notes-table-container"},[_c('div',{staticClass:"notes-table-row"},[_c('div',{staticClass:"notes-table-label"},[_vm._v(" Notes ")]),_c('div',{staticClass:"notes-table-value"},_vm._l((_vm.text),function(value,index){return _c('span',{key:_vm.text + index},[_vm._v(" "+_vm._s(value)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }